import React from "react";

function TodoError (){
    return (
        <p>Panic, there is an error coming!</p>
    );
}

export { TodoError }

